import React from "react";
import { useSelector } from "react-redux";
import DashboardUtils from "../../../utils/DashboardUtils";

import DashboardNavCollapse from "./DashboardNavCollapse";
import DashboardNavItem from "./DashboardNavItem";
import DashboardNavLink from "./DashboardNavLink";

const DashboardNavGroup = (props) => {
  const { item } = props;

  const userRole = useSelector(({ auth }) => auth.user.role);
  if (!DashboardUtils.hasPermission(item.auth, userRole)) {
    return null;
  }

  return (
    <>
      <b className="d-block py-2 pl-3 text-muted">{item.title}</b>

      {item.children && (
        <React.Fragment>
          {item.children.map((item) => (
            <React.Fragment key={item.id}>
              {item.type === "group" && <NavGroup item={item} />}

              {item.type === "collapse" && <DashboardNavCollapse item={item} />}

              {item.type === "item" && <DashboardNavItem item={item} />}

              {item.type === "link" && <DashboardNavLink item={item} />}
            </React.Fragment>
          ))}
        </React.Fragment>
      )}
    </>
  );
};

const NavGroup = React.memo(DashboardNavGroup);

export default NavGroup;
